import React, { useState, useEffect, useRef } from 'react'
import './NewAddTask.css'
import axios from 'axios';
import { setAddTask, setLevelAddTaskFlag, setLevelMonthAddTaksFlag, setMonthAddTaskFlag, setMonthData, setNewTask, setWeekAddTaskFlag } from '../../../erpStore/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import profile from "../../../assets/images/profile.png";
import { setInitialDataObject, setDispatchAllTask, setProjectToUpadte } from '../../../erpStore/actions';
import { Calendar } from "primereact/calendar";
import moment from 'moment'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


function NewAddTask(props) {

  const [dateFlag, setDateFlag] = useState(false)
  const dispatch = useDispatch()
  const defaultTag = useSelector((state) => state.data.empSelectedTag)
  const stringHeaders = window.localStorage.getItem('myHeaders');
  const storedHeaders = JSON.parse(stringHeaders);
  const selfInfo = useSelector((state) => state.data.selfData)
  const url = useSelector((state) => state.data.apiUrl)
  const empInfo = useSelector((state) => state.data.empInfo)
  var taskDate = useSelector((state) => state.data.fullDate)
  var dateObj = new Date(taskDate);
  var year = dateObj.getFullYear();
  var month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
  var day = ('0' + dateObj.getDate()).slice(-2);
  var formattedDateString = year + '-' + month + '-' + day;
  taskDate = formattedDateString
  const levelMonthAddTaskFlag = useSelector((state) => state.data.levelMonthAddTaskFlag)
  const [seletedAssigneeForList, setSelectedAssigneeForList] = useState([])
  const [runTimeTaskObj, setRunTimeTaskObj] = useState([]);
  const [assigneeListNewTaskAdd, setAssgneeListInNewTaskAdd] = useState(false)
  const [tagListForNewAddTask, setTagListInNewTaskAdd] = useState(false)
  const [priorityListForNewAddTask, setPriorityListForNewAddTask] = useState(false)
  const [statusListForNewAddTask, setStatusListForNewAddTask] = useState(false)
  const [projectListForNewAddTask, setProjectLitForNewAddTask] = useState(false)
  const routeS = useSelector((state) => state.data.route)
  const [seletedTagsForList, setSelectedTagsForList] = useState((routeS !== 'level' && routeS !== 'projects') ? ([defaultTag ? selfInfo.department : empInfo.department]) : [])
  const [newTask, setNewTasks] = useState('');
  const assigneeRef = useRef(null)
  const newAddTagRef = useRef(null)
  const newAddPriorityRef = useRef(null)
  const newAddStatusRef = useRef(null)
  const newAddProjectRef = useRef(null)
  const view = useSelector((state) => state.data.view)
  const route = useSelector((state) => state.data.route)
  const [clicked, setClicked] = useState(false);
  const [listOfTaskObj, setListOfTaskObj] = useState([])
  const self = useSelector((state) => state.data.selfData)
  const [regularTask, setRegularTask] = useState([])
  const [DueDate, setPostDate] = useState(taskDate)
  const dispatchAllTask = useSelector((state) => state.data.dispatchAllTask)
  const [tempAllTask, setTempAllTask] = useState(dispatchAllTask)
  const [errMsgTsk, setErrMsg] = useState('')
  const [tipPDT, setTipPDT] = useState(false)
  const [taskIndex, setTaskIndex] = useState(null)
  const [tipPDTCancel, setTipPDTCancel] = useState(false)
  const [tipTask, setTipTask] = useState(false)
  const [tipPredefineTask, setTipPredefineTask] = useState(false)
  const [charCount, setCharCount] = useState(50)
  const dateRef = useRef(null)
  const searchedDate = useSelector((state) => state.data.searchedDate)
  const [endDateFlag, setEndDateFlag] = useState(false)
  const endDateRef = useRef(null)

  const [endDate, setEndDate] = useState(taskDate)
  const selfInfoEmp = useSelector((state) => state.data.taskEmp)

  // const dAssignees = useSelector((state) => state.data.assgineeList)
  const [assigneeList, setAssineeList] = useState([])
  const [selectedAssignee, setSelectedAssignee] = useState()

  const [tempProjectList, setTempProjectList] = useState([])


  let currentTime = new Date();

    // Extract hours, minutes, and seconds
    let hours = currentTime.getHours();
    let minutes = currentTime.getMinutes();
    let seconds = currentTime.getSeconds();

    // Pad single digit values with leading zeros
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    // Format the time as "HH:mm:ss"
    let formattedTime = hours + ':' + minutes + ':' + seconds;

    // Store the formatted time in a local variable
    let localTime = formattedTime;

  const [taskViewEmp, setTaskViewEmp] = useState(
            (self?.role?.[0]?.roleLevel?.toString() === '1' || selfInfoEmp?.role?.[0]?.roleLevel?.toString() === '2')
            ? [{ 
                "empFullName": self?.empFullName, 
                "empId": self?.empId, 
                "empImg": self?.empImg, 
                "viewedTimeStamp": `${DueDate} ${localTime}`
              }]
            : (self?.role?.[0]?.roleLevel?.toString() === selfInfoEmp?.role?.[0]?.roleLevel?.toString())
              ? []
              : [{ 
                  "empFullName": self?.empFullName, 
                  "empId": self?.empId, 
                  "empImg": self?.empImg, 
                  "viewedTimeStamp": `${DueDate} ${localTime}`
                }])

  const handleSelectedAssignee = (data) => {
    setSelectedAssignee(data)
    setAssgneeListInNewTaskAdd(!assigneeListNewTaskAdd)
  }

  const dTags = useSelector((state) => state.data.tagList)
  const [tagsList, setTagsList] = useState(dTags)

  const dPriorities = useSelector((state) => state.data.priorityList)
  const [selectedPriority, setSelectedPriority] = useState(dPriorities[0])
  const [priorityList, setPriorityList] = useState(dPriorities?.filter(obj => obj?.priorityId !== selectedPriority?.priorityId))

  const handleSelectedPriority = (data) => {
    setSelectedPriority(data)
    setPriorityListForNewAddTask(!priorityListForNewAddTask)

  }


  const dVerifieds = useSelector((state) => state.data.verifiedList)
  // const foundVerified = dVerifieds.find(verified => verified.verificationStatusId === 3)
  const [verifieses, setVerifies] = useState(dVerifieds)

  const dStatuses = useSelector((state) => state.data.statusList)
  // const foundStatus = statusList.find(status => status.statusId === 1);
  const [selectedStatus, setSelectedStatus] = useState(dStatuses[0])
  const [statusList, setStatusList] = useState(dStatuses?.filter(obj => obj?.statusId !== selectedStatus?.statusId))


  const handleSelectedStatus = (data) => {
    setSelectedStatus(data)
    setStatusListForNewAddTask(!statusListForNewAddTask)
  }

  var projectUpdate = useSelector((state) => state.data.projectToUpadte)
  const [projectList, setProjectList] = useState([])
  const [selectedProject, setSelectedProject] = useState(route !== 'projects' ? null : projectUpdate)
  const handleTaskProject = (data) => {
    setSelectedProject(data)
    setProjectLitForNewAddTask(!projectListForNewAddTask)
  }


  const [plainText, setPlainText] = useState('');

  // const extractPlainText = (html) => {
  //   const tempElement = document.createElement('div');
  //   tempElement.innerHTML = html;
  //   return tempElement.textContent || tempElement.innerText || '';
  // };
  function extractPlainText(html) {
    // Replace closing tags with closing tags followed by newline character
    const replacedHtml = html.replace(/<\/(p|h2|h3|h4)>/g, '</$1>\n');

    // Convert HTML to plain text
    const doc = new DOMParser().parseFromString(replacedHtml, 'text/html');
    return doc.body.textContent || '';
  }

  const [addPostTaskComment, setPostTaskComment] = useState()
  const handlePostTaskComment = (e) => {
    const cmtValue = JSON.stringify(e)
    setPostTaskComment(cmtValue)
  }


  const handleInputChange = (e) => {
    if (e.target.value.length <= 100) {
      setNewTasks(e.target.value);
      if (e.target.value.length > 0) {
        setErrMsg('Press "ENTER" to add task in task list...')
        setCharCount(100 - e.target.value.length)
      } else if (e.target.value === '') {
        setErrMsg('')
      }
    }
  };

  const handleKeyDown = (e) => {
    const inputDate = DueDate;
    const originalDate = new Date(DueDate);

    if (e.key === 'Enter') {
      setCharCount(50)
      if (newTask.trim() === '') {
        setNewTasks('')
        setErrMsg('plz add the task first')
        return
      }

      const updatedTasks = [{ taskName: newTask }, ...runTimeTaskObj];
      setRunTimeTaskObj(updatedTasks);
      setNewTasks('');
      setErrMsg('')
    }
  };

  useEffect(() => {
    const updatedList = listOfTaskObj.map((taskObj, index) => {
      taskObj.priorityEntity = selectedPriority;
      taskObj.statusEntity = selectedStatus;
      taskObj.task_verified = { "verificationStatusId": 3, "verificationStatus": "Not Verified" };
      taskObj.tags = seletedTagsForList;
      taskObj.projectEntity = selectedProject ? selectedProject : null;
      taskObj.taskComment = addPostTaskComment;
      taskObj.taskSchedule = DueDate;
      taskObj.taskDueDate = DueDate;
      return taskObj;
    });
    setListOfTaskObj(updatedList)
  }, [selectedPriority, selectedStatus, seletedTagsForList, selectedProject, addPostTaskComment]);

  useEffect(() => {
    const stringHeaders = window.localStorage.getItem('myHeaders');
    const storedHeaders = JSON.parse(stringHeaders);

    const regularTaskUrl = `${url}task/regular/get`;
    axios.get(regularTaskUrl, {
      headers: storedHeaders,
    })
      .then(response => {
        setRegularTask(response?.data);

      })
      .catch(error => {
      });

  }, [props]);

  const [selectedRegularTasks, setSelectedRegularTasks] = useState([]);

  const handleCheckboxChange = (regTask) => {
    // Check if the task is already selected
    const isTaskSelected = selectedRegularTasks.some(task => task.regularTaskName === regTask.regularTaskName);

    // If selected, remove from the list; otherwise, add to the list
    if (isTaskSelected) {
      setSelectedRegularTasks(prevTasks => prevTasks.filter(task => task.regularTaskName !== regTask.regularTaskName));
    } else {
      setSelectedRegularTasks(prevTasks => [...prevTasks, regTask]);
    }

  };

  useEffect(() => {
    setRunTimeTaskObj(runTimeTaskObj)
  }, [runTimeTaskObj]);

  const handleDeleteTask = (index) => {
    const updatedTaskList = [...runTimeTaskObj]; // Create a copy of the task list
    updatedTaskList.splice(index, 1); // Remove the task at the specified index
    setRunTimeTaskObj(updatedTaskList);

    const tempListOfTaskObj = [...listOfTaskObj]
    tempListOfTaskObj.splice(index, 1)
    setListOfTaskObj(tempListOfTaskObj)
  };

  const postTask = () => {

    setClicked(true)
    if (runTimeTaskObj.length === 0 && selectedRegularTasks.length === 0) {
      toast.error("Please Add the task first", {autoClose: 2000 });
      setClicked(false)
      return
    } else if (DueDate === '') {
      toast.error("Please Select Start Date", { toastId: 'success', autoClose: 2000 });
      setClicked(false)
      return
    }

    const taskNamesList = runTimeTaskObj.map(taskObject => taskObject.taskName);
    const regTaskList = selectedRegularTasks.map(regObject => regObject.regularTaskName)
    const totalTaskList = [...taskNamesList, ...regTaskList]
    const assigniesPostList = seletedAssigneeForList ? seletedAssigneeForList.map(empAssignee => parseInt(empAssignee.empId)) : []
    const tagPostList = seletedTagsForList ? seletedTagsForList.map(tagObj => tagObj.departmentId) : null

    if(totalTaskList.length === 0){
      toast.error('please add task title', {autoClose: 2000})
      return
    }

    totalTaskList.forEach((taskTitle) => {
      const newTaskObj = {
        "taskId": null,
        "taskTitle": taskTitle,
        "priorityEntity": selectedPriority,
        "projectEntity": selectedProject,
        "statusEntity": selectedStatus,
        "tags": seletedTagsForList,
        "employee": [self.empId],
        "taskComment": addPostTaskComment,
        "taskDone": selectedStatus.statusId === 6 ? 1 : 0,
        "taskDueDate": endDate,
        "taskOwner": { "empId": self.empId, "empFullName": self.empFullName, "empImg": `${self.empImg}`},
        "task_verified": verifieses[0],
        "taskOwnerImage": self.empImg,
        "taskGitLink": null,
        "taskSchedule": DueDate,
        "taskTimeFrom" : null,
        "taskTimeTo" : null,
        "taskView" : taskViewEmp,
        'request': {
          "task_verified": false,
          "taskDueDate": false,
          "taskSchedule": false,
          "projectEntity": false,
          "statusEntity": selectedStatus.statusId === 5 ? true : false,
          "taskGitLink": false,
          "taskTitle": false,
          "priorityEntity": false,
          "taskDelete": false,
          "taskTransfer": false,
          "taskCard" : false,
        }
      }
      console.log(newTaskObj.taskView)
      newTaskObj.taskView = newTaskObj.taskView
      listOfTaskObj.push(newTaskObj)
    })

    listOfTaskObj.reverse()

    const postTaskContent = {
      "taskTitle": totalTaskList.reverse(),
      "employee": route === 'projects' ? assigniesPostList : (route === "mytask" ? ([selfInfo.empId]) : route !== 'mytask' && (view === 'month' || view === 'week' || view === 'day') ? ([empInfo.empId]) : assigniesPostList),
      "taskComment": addPostTaskComment,
      "taskScheduleDate": DueDate,
      "taskDueDate": endDate,
      "taskPriority": selectedPriority ? selectedPriority.priorityId : null,
      "taskStatus": selectedStatus ? selectedStatus.statusId : null,
      "taskProject": selectedProject ? selectedProject.projectId : null,
      "taskOwner": selfInfo.empId,
      "taskTags": tagPostList,
      'taskLevel': dispatchAllTask && dispatchAllTask.length > 0 ? dispatchAllTask.length + 1 : 1,
      
    }
    if (postTaskContent['employee'].length === 0) {
      toast.error('Please Select the assignee first', { autoClose: 2000 })
      setClicked(false)
      return
    }

    if (route === 'projects') {
      axios.post(`${url}task/add`, postTaskContent, { headers: storedHeaders, })
        .then(response => {
          if (response.request.status === 201) {
            dispatch(setDispatchAllTask([]))
            axios.post(`${url}project/task/get/all?page=${0}&size=${100}`, { "projectId": projectUpdate.projectId }, { headers: storedHeaders })
              .then(response => {
                if (response.request.status === 200) {
                  dispatch(setDispatchAllTask(response.data.data))
                  toast.success(`Task Added Successfully on: ${DueDate}`, { toastId: 'success', autoClose: 2000 });
                  dispatch(setAddTask(false))
                  setClicked(false)
                }
              })
              .catch(err => {
                if (err.response.status === 500) {
                  // dispatch(setProjectToUpadte(null))
                  setClicked(false)

                }
                setClicked(false)
                toast.error(`${err.response.status} error occured`, { toastId: 'success', autoClose: 2000 });
              })
          }
        })
        .catch(err => {
          dispatch(setProjectToUpadte(null))
          toast.error("Something is wrong try again", { toastId: 'success', autoClose: 2000 });
        })
    } else {
      if (view === 'level') {
        if(totalTaskList.length === 0){
          toast.error('please add task title', {autoClose: 2000})
          return
        }

        const postTaskContent = {
          "taskTitle": totalTaskList,
          "employee": assigniesPostList,
          "taskComment": addPostTaskComment,
          "taskScheduleDate": DueDate,
          "taskDueDate": endDate,
          "taskPriority": selectedPriority ? selectedPriority.priorityId : null,
          "taskStatus": selectedStatus ? selectedStatus.statusId : null,
          "taskProject": selectedProject ? selectedProject.projectId : null,
          "taskOwner": selfInfo.empId,
          "taskTags": tagPostList,
          'taskLevel': dispatchAllTask && dispatchAllTask.length > 0 ? dispatchAllTask.length + 1 : 1
        }

        axios.post(`${url}task/add`, postTaskContent, { headers: storedHeaders, })
          .then(response => {
            if (response.request.status === 201) {
              if (response.data === 'Task Added Successfully') {
                dispatch(setDispatchAllTask(tempAllTask))
                toast.success(`Task Added Successfully on: ${DueDate}`, { toastId: 'success', autoClose: 2000 });
                dispatch(setAddTask(false))
                dispatch(setNewTask(response.data))
                setSelectedProject(null)
                setClicked(false)
              } else {
                listOfTaskObj.map((obj, index) => {
                  obj.taskId = response.data[index].taskId
                  obj.request = response.data[index].requestEntity
                  listOfTaskObj[index] = obj
                });

                listOfTaskObj.forEach(obj => {
                  tempAllTask.push(obj)
                })
                dispatch(setDispatchAllTask(tempAllTask))
                toast.success(`Task Added Successfully on: ${DueDate}`, { toastId: 'success', autoClose: 2000 });
                dispatch(setAddTask(false))
                dispatch(setNewTask(response.data))
                setClicked(false)
              }

              if(view === 'level' && routeS === 'level'){
                dispatch(setLevelAddTaskFlag(true))
              }
              
            }

          })
          .catch(err => {
            setClicked(false)
            dispatch(setAddTask(false))
            toast.error("Something is wrong try again", { toastId: 'success', autoClose: 2000 });
          })
      } else {
          if(listOfTaskObj.length === 0){
            toast.error('please add task title', {autoClose: 2000})
            return
          }
        
        if(DueDate > taskDate){
          axios.post(`${url}task/add`, postTaskContent, { headers: storedHeaders, })
          .then(response => {
            if (response.request.status === 201) {
              dispatch(setLevelMonthAddTaksFlag(true))
              dispatch(setAddTask(false))
              setClicked(false)
              toast.success(`Task Added Successfully on: ${DueDate}`, { toastId: 'success', autoClose: 2000 });
            }

          })
          .catch(err => {
            setClicked(false)
            dispatch(setAddTask(false))
            toast.error("Something is wrong try again", { toastId: 'success', autoClose: 2000 });
          })
        }else{
        
          dispatch(setLevelMonthAddTaksFlag(true))
          axios.post(`${url}task/add`, postTaskContent, { headers: storedHeaders, })
          .then(response => {
            if (response.request.status === 201) {
              const DueDateTemp = new Date(DueDate);
              const endDateTemp = new Date(endDate);
              const taskDateTemp = new Date(taskDate);
              if (DueDateTemp <= taskDateTemp <= endDateTemp) {
                toast.success(`Task Added Successfully on: ${DueDate}`, { toastId: 'success', autoClose: 2000 });
                dispatch(setAddTask(false))
                if( selectedStatus?.statusId !== 5 && selectedStatus?.statusId !== 6 ){
                  listOfTaskObj.map((obj, index) => {
                    obj.taskId = response.data[index].taskId
                    obj.request = response.data[index].requestEntity
                    obj.taskView = taskViewEmp
                    listOfTaskObj[index] = obj
                  });
                  listOfTaskObj.forEach(obj => {
                    tempAllTask.push(obj)
                  })
                }else{
                  if( (selectedStatus?.statusId === 5 || selectedStatus?.statusId === 6) && ( taskDateTemp?.toString() === DueDateTemp?.toString() )){
                  listOfTaskObj.map((obj, index) => {
                    obj.taskId = response.data[index].taskId
                    obj.request = response.data[index].requestEntity
                    obj.taskView = taskViewEmp
                    listOfTaskObj[index] = obj
                  });
  
                  listOfTaskObj.forEach(obj => {
                    tempAllTask.push(obj)
                  })
                }
                }

                setClicked(false)
              } else {
                listOfTaskObj.map((obj, index) => {
                  obj.taskId = response.data[index].taskId
                  obj.request = response.data[index].requestEntity
                  listOfTaskObj[index] = obj
                });

                listOfTaskObj.forEach(obj => {
                  tempAllTask.push(obj)
                })
                toast.success(`Task Added Successfully on: ${DueDate}`, { toastId: 'success', autoClose: 2000 });
                dispatch(setAddTask(false))
                dispatch(setNewTask(response.data))
                setClicked(false)
              }
            }

          })
          .catch(err => {
            setClicked(false)
            dispatch(setAddTask(false))
            toast.error("Something is wrong try again", { toastId: 'success', autoClose: 2000 });
          })
        }
        
      }
    }

    if (routeS === 'mytask' || routeS === 'level') {
      if (view === 'month') {
          dispatch(setMonthAddTaskFlag(true))
      }else if(view === 'week'){
        dispatch(setWeekAddTaskFlag(true))
      }
  } 
    
  }


  useEffect(() => {
    function handleOutsideClick(event) {
      if (assigneeRef && assigneeRef.current && !assigneeRef.current.contains(event.target)) {
        setAssgneeListInNewTaskAdd(false)
      } else if (newAddTagRef && newAddTagRef.current && !newAddTagRef.current.contains(event.target)) {
        setTagListInNewTaskAdd(false)
      } else if (newAddPriorityRef && newAddPriorityRef.current && !newAddPriorityRef.current.contains(event.target)) {
        setPriorityListForNewAddTask(false)
      } else if (newAddStatusRef && newAddStatusRef.current && !newAddStatusRef.current.contains(event.target)) {
        setStatusListForNewAddTask(false)
      } else if (newAddProjectRef && newAddProjectRef.current && !newAddProjectRef.current.contains(event.target)) {
        setProjectLitForNewAddTask(false)
      } else if (dateRef && dateRef.current && !dateRef.current.contains(event.target)) {
        setDateFlag(false)
      } else if (endDateRef && endDateRef.current && !endDateRef.current.contains(event.target)) {
        setEndDateFlag(false)
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [])

  useEffect(() => {
    setRegularTask(regularTask)
  }, [regularTask])


  useEffect(() => {
    setAssineeList([])
    if (seletedTagsForList.length > 0) {
      const departmentIdArray = seletedTagsForList.map(dapertment => dapertment.departmentId);
      axios.post(`${url}project/get/assignee`, { department: departmentIdArray }, { headers: storedHeaders })
        .then((response) => {
          if (response.request.status === 200) {
            setAssineeList(response.data)
            var filteredSecondArray = response.data.filter(employee =>
              seletedAssigneeForList.some(({ empId }) => empId === employee.empId)
            );
            setSelectedAssigneeForList(filteredSecondArray)
          }
        })
        .catch((error) =>{})
    } else {
      setSelectedAssignee([])
      setSelectedAssigneeForList([])
    }
  }, [seletedTagsForList])
  const [text, setText] = useState('')


  useEffect(() => {
    if (view !== 'level') {
      axios.post(`${url}project/get/all/for-employee`, { "userId": selfInfoEmp?.userId }, { headers: storedHeaders })
        .then(response => {
          if (response.request.status === 200) {
            setProjectList(response.data)
            setTempProjectList(response.data)
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 500) {
            // navigate("/server-error")
          }
        })
    } else {
      axios.get(`${url}project/get/all`, { headers: storedHeaders })
        .then(response => {
          if (response.request.status === 200) {
            setProjectList(response.data)
            setTempProjectList(response.data)
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 500) {
            // navigate("/server-error")
          }
        })
    }

  }, [])

  const updatePriotityList = (priotityObj) => {
      const tempList = dPriorities.filter(Obj => Obj?.priorityId !== priotityObj?.priorityId)
      setPriorityList(tempList)
  }

  const updateStatusList = (statusObj) => {
    const tempList = dStatuses.filter(Obj => Obj?.statusId !== statusObj?.statusId)
    setStatusList(tempList)
  }

  const updateProjectList = (projectObj) => {
    const tempList = projectList?.filter(Obj => Obj?.projectId !== projectObj?.projectId)
    setTempProjectList(tempList)
  }

  const updateDepartmentList = (updatedList) => {
    let tempList = dTags;
    updatedList.forEach(tagObj => {
      tempList = tempList?.filter(Obj => Obj?.departmentId !== tagObj?.departmentId);
    });
    setTagsList(tempList);
  };

  return (
    <div className='new_Task_mainContainer'>
      <div className='newTask_template_Container' id='unloadElement'>
        <div className='newTask_header'>
          <div className='newTask_header_cross_icon'>
            <svg onClick={() => {
              const unloadElement = document.getElementById('unloadElement');
              if (unloadElement) {
                unloadElement.classList.add('fade-out');
              }
              setTimeout(function () {
                dispatch(setAddTask(false))
              }, 1000)
            }} width="22" height="22" style={{ marginLeft: '15px' }} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#263238" />
            </svg>
          </div>
          <div className='newTask_Profile_info'>
            <div className='newTask_userName'>
              <div className='img-holder'>
                <img src={selfInfo && selfInfo.empImg ? selfInfo.empImg : profile} alt="" />
              </div>
              <div className='empInfo-name-holder'>
                <p>{props.props.empFullName}</p>
              </div>

            </div>
            <div className='newTask_Notification'>
              {/* <svg width="32" height="33" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6.10305 0.0128568L6.08027 0.000677966C5.99553 0.000677966 5.91098 0.000677967 5.82725 0C5.50742 0.125153 5.38125 0.362911 5.41313 0.69835C5.41818 0.751721 5.4168 0.805763 5.41543 0.859865C5.41422 0.907526 5.413 0.955249 5.41618 1.00258C5.42228 1.09552 5.39515 1.13147 5.29543 1.14809C3.54023 1.44045 2.20187 2.9908 2.16863 4.77177C2.16199 5.12331 2.16308 5.47485 2.16418 5.82639C2.16471 5.99514 2.16523 6.16388 2.1649 6.33263C2.16388 6.93432 2.03805 7.5065 1.76129 8.04306C1.54355 8.46499 1.25254 8.82892 0.895392 9.14231C0.486015 9.50081 0.420555 10.056 0.735304 10.4603C0.946607 10.732 1.23219 10.8358 1.56932 10.8354C3.84334 10.8341 6.11737 10.8342 8.39139 10.8344L10.3382 10.8344L10.3527 10.8344C10.3817 10.8345 10.4106 10.8345 10.4396 10.8331C11.0145 10.8022 11.411 10.3528 11.3615 9.78232C11.3364 9.49471 11.176 9.28544 10.967 9.09788C10.2426 8.44735 9.82436 7.63538 9.76399 6.6623C9.74285 6.32142 9.74376 5.97907 9.74467 5.63665C9.74528 5.40772 9.74589 5.17875 9.73991 4.95018C9.73279 4.67681 9.72092 4.39835 9.66529 4.13176C9.33935 2.56615 8.16413 1.43129 6.58733 1.1447C6.51136 1.13079 6.49033 1.1006 6.49169 1.0287C6.49508 0.859794 6.4961 0.690209 6.49033 0.521303C6.48253 0.296773 6.36789 0.140754 6.16676 0.045787C6.14529 0.035552 6.12419 0.0242147 6.10305 0.0128568Z" fill="#FF8402" />
                <path fillRule="evenodd" clipRule="evenodd" d="M1.94262 0.600171C0.731109 1.84831 0.087704 3.34235 0.00528583 5.07822C0.00528583 5.11598 0.00396383 5.15389 0.0026421 5.19179C-0.000322873 5.27683 -0.00328649 5.36182 0.00867773 5.44487C0.0449689 5.69721 0.25695 5.88002 0.503865 5.89121C0.771131 5.90342 0.996678 5.743 1.05773 5.48455C1.07558 5.40811 1.07737 5.32708 1.07915 5.24693C1.07953 5.22965 1.07991 5.21238 1.08045 5.19524C1.1103 4.27948 1.33788 3.41799 1.77948 2.61416C2.03352 2.15153 2.34793 1.73401 2.7183 1.35855C2.85363 1.22153 2.92926 1.0611 2.89535 0.86608C2.85736 0.647994 2.73085 0.497063 2.51717 0.431604C2.29095 0.362413 2.10305 0.434996 1.94262 0.600171ZM11.9034 5.07589C11.9034 5.11271 11.9047 5.14972 11.9059 5.18674C11.9088 5.26842 11.9116 5.35017 11.9007 5.42999C11.8613 5.7193 11.6202 5.90754 11.3288 5.89092C11.0561 5.87532 10.8329 5.64671 10.8296 5.36249C10.8221 4.73198 10.7292 4.11706 10.5257 3.51944C10.2628 2.74783 9.85139 2.06543 9.29482 1.47052C9.27796 1.45245 9.26085 1.4346 9.24373 1.41673C9.20818 1.37963 9.17255 1.34245 9.13914 1.30331C8.94615 1.07743 8.96006 0.759964 9.16966 0.558497C9.37893 0.35737 9.70792 0.343802 9.91312 0.55714C10.1556 0.809821 10.3917 1.07234 10.5999 1.35317C11.4187 2.45717 11.843 3.70395 11.9034 5.07589ZM7.92396 11.3788H3.97468C4.11679 12.2183 4.94877 13.0597 6.07956 12.9967C6.97633 12.9465 7.92362 12.1175 7.92396 11.3788Z" fill="#263238" />
              </svg> */}
            </div>
          </div>
        </div>
        <div className='newTaskTemplate_scroller'>
          <div className='taskTemplate_actual_Scroller'>
            <div className='NewAddTask_heading'>
              <p>New Tasks</p>
            </div>

            <div className='AddedTaskDiv'>
              <div className='task-input-container'>
                <input type="text" placeholder='Enter Tasks Name ' value={newTask} onChange={handleInputChange} onKeyDown={handleKeyDown} />
                <div className='text-count'>{newTask.length > 0 ? `${charCount}/100` : null}</div>
              </div>
              <p className='errorMsgforTsk'>{runTimeTaskObj.length <= 0 && newTask.length === 0 ? `${errMsgTsk}` : `${errMsgTsk}`}</p>
              {/* <p className='errorMsgforTsk countMsgforTsk'>{newTask.length > 0 ? `${charCou nt}/100` : null}</p> */}
            </div>
            <div className='TaskListViewContainer'>
              <div className='RunTimeDefinedTaskListViewContainer'>
                <div className='List1'>
                  {runTimeTaskObj.map((obj, index) => (
                    <div className='taskSubject' key={index}>
                      <h5>{runTimeTaskObj.length - index}</h5>
                      <div className='newTaskParagraph' onMouseEnter={() => {
                        setTipTask(!tipTask)
                        setTaskIndex(index)
                      }} onMouseLeave={() => { setTipTask(false) }}><div className='newTaskPragraph-content' >{obj.taskName.length > 40 ? obj.taskName.substring(0, 40) + '...' : obj.taskName}</div></div>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                        axios.post(`${url}task/regular/add`, { "regularTaskName": obj.taskName, "employee": { "empId": selfInfo.empId } }, { headers: storedHeaders })
                          .then(response => {
                            regularTask.push({
                              "regularTaskName" :  obj.taskName,
                              "regularTaskId" : response.data.regularTaskId
                            })
                            setRegularTask(regularTask)
                            toast.success("added successfully", { toastId: 'success', autoClose: 2000 });
                          })
                          .catch(error => {
                            toast.error(`${error.message}`, {autoClose : 2000})
                          })
                      }}
                        onMouseEnter={() => {
                          setTipPDT(true)
                          setTaskIndex(index)
                        }}
                        onMouseLeave={() => { setTipPDT(false) }}>

                        <rect width="14" height="14" rx="2" fill="#D9D9D9" />
                        <path d="M10.5606 6.55538C10.8033 6.55538 11 6.75211 11 6.9948C11 7.23748 10.8033 7.43421 10.5606 7.43421H3.43942C3.19673 7.43421 3 7.23748 3 6.9948C3 6.75211 3.19673 6.55538 3.43942 6.55538H10.5606ZM6.99817 3.00021C7.24355 3.00033 7.44241 3.19928 7.44241 3.44466V10.5553C7.44241 10.8009 7.24329 10.9999 6.99775 10.9998C6.75237 10.9997 6.55352 10.8007 6.55352 10.5553V3.44466C6.55352 3.19912 6.75263 3.0001 6.99817 3.00021Z" fill="#263238" />
                      </svg>

                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => handleDeleteTask(index)}>
                        <rect width="14" height="14" rx="2" fill="#D9D9D9" />
                        <path d="M8.86017 4.16789C9.03177 3.99629 9.31 3.99629 9.4816 4.16789C9.6532 4.3395 9.6532 4.61772 9.4816 4.78932L4.44618 9.82475C4.27457 9.99635 3.99635 9.99635 3.82475 9.82475C3.65314 9.65314 3.65314 9.37492 3.82475 9.20332L8.86017 4.16789ZM3.82729 4.17301C4.00088 3.99959 4.28217 3.99966 4.45568 4.17317L9.48369 9.20118C9.65731 9.3748 9.65725 9.65633 9.48354 9.82987C9.30995 10.0033 9.02866 10.0032 8.85515 9.82972L3.82714 4.80171C3.65351 4.62808 3.65358 4.34656 3.82729 4.17301Z" fill="#263238" />
                      </svg>

                      {tipPDT && index === taskIndex &&
                        <div className='tast-add-prd'>
                          Add to Predefined
                        </div>
                      }

                      {tipTask && index === taskIndex &&
                        <div className='tipForNewTask'>
                          <p className='tipForNewTaskPara'>
                            {obj.taskName}
                          </p>
                        </div>
                      }

                    </div>
                  ))}
                </div>
              </div>

              {regularTask && regularTask?.length > 0 && <div className='predefinedDistinguish'><hr style={{ borderColor: 'rgb(231 234 235)', width: '35%', opacity: '0.5' }} />Predefined Tasks<hr style={{ borderColor: 'rgb(231 234 235)', width: '35%', opacity: '0.5', marginRight: '0px' }} /></div>}
              <div className='PreDefinedTaskListViewContainer'>
                {regularTask && regularTask && regularTask.length > 0 && regularTask?.map((regTask, index) => (
                  <div className='taskSubject' key={index}>
                    <input type="checkbox" style={{ cursor: 'pointer' }}
                      onChange={() => handleCheckboxChange(regTask)}
                      checked={selectedRegularTasks.some(task => task.regularTaskName === regTask.regularTaskName)}
                    />
                    <p onMouseEnter={() => {
                      setTipPredefineTask(!tipPredefineTask)
                      setTaskIndex(index)
                    }}
                      onMouseLeave={() => { setTipPredefineTask(false) }}
                      className='newTaskParagraph' title={regTask.regularTaskName}>{regTask.regularTaskName.length > 40 ? regTask.regularTaskName.substring(0, 40) + '...' : regTask.regularTaskName}</p>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                      var regularTskId = regTask.regularTaskId
                      axios.delete(`${url}task/regular/delete/${regTask.regularTaskId}`, { headers: storedHeaders })
                        .then(response => {
                          if (response.request.status === 200) {
                            toast.success("removed successfully", { toastId: 'success', autoClose: 2000 });
                            const tempSelectedRegTask = []
                            selectedRegularTasks.forEach((task) => {
                              if (regularTskId !== task.regularTaskId) {
                                tempSelectedRegTask.push(task)
                              }

                            })
                            setSelectedRegularTasks(tempSelectedRegTask)
                            const temRegTask = regularTask.filter((obj) => obj.regularTaskId !== regTask.regularTaskId)
                            setRegularTask(temRegTask)
                          }
                        })
                        .catch(error => {})
                    }}

                      onMouseEnter={() => {
                        setTaskIndex(index)
                        setTipPDTCancel(true)
                      }}

                      onMouseLeave={() => {
                        setTipPDTCancel(false)
                      }}
                    >
                      <rect width="14" height="14" rx="2" fill="#D9D9D9" />
                      <path d="M8.86017 4.16789C9.03177 3.99629 9.31 3.99629 9.4816 4.16789C9.6532 4.3395 9.6532 4.61772 9.4816 4.78932L4.44618 9.82475C4.27457 9.99635 3.99635 9.99635 3.82475 9.82475C3.65314 9.65314 3.65314 9.37492 3.82475 9.20332L8.86017 4.16789ZM3.82729 4.17301C4.00088 3.99959 4.28217 3.99966 4.45568 4.17317L9.48369 9.20118C9.65731 9.3748 9.65725 9.65633 9.48354 9.82987C9.30995 10.0033 9.02866 10.0032 8.85515 9.82972L3.82714 4.80171C3.65351 4.62808 3.65358 4.34656 3.82729 4.17301Z" fill="#263238" />
                    </svg>


                    {tipPDTCancel && index === taskIndex &&
                      <div className='tast-add-prd'>
                        Remove
                      </div>
                    }

                    {tipPredefineTask && index === taskIndex &&
                      <div className='tipForNewTask'>
                        <p className='tipForNewTaskPara'>
                          {regTask.regularTaskName}
                        </p>
                      </div>
                    }

                  </div>
                ))}
              </div>
            </div>
            <div className='TemplateTaskInput'>
              <div className='StartDate'>
                <label>Start Date</label>
                <div className='taskEdtSelectDateForAdd' onClick={() => { setDateFlag(true) }}>
                  <p style={{ fontFamily: 'Roboto', fontSize: '15px', }}>{DueDate}</p>
                  <div className='taskEdtSelectDateIcon'>
                    <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }}>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                      <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                      <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
                    </svg>
                  </div>

                  {dateFlag &&
                    <div className='calender-holder-dashboard calender-holder-card' ref={dateRef}>
                      <Calendar value={moment(DueDate).toDate()} inline onChange={(e) => {
                        setDateFlag(false)
                        const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                        setPostDate(formattedDate)
                        setDateFlag(false)
                        setEndDate(formattedDate)
                      }} unstyled={false} minDate={new Date(self.empJoiningDate)} />
                    </div>
                  }
                </div>
              </div>

              <div className='StartDate'>
                <label>End Date&nbsp;&nbsp;</label>

                <div className='taskEdtSelectDateForAdd' onClick={() => { 
                  setEndDateFlag(true) 
                  }}>
                  <p style={{ fontFamily: 'Roboto', fontSize: '15px', }}>{endDate}</p>
                  <div className='taskEdtSelectDateIcon'>
                    <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }}>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                      <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                      <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
                    </svg>
                  </div>
                  {endDateFlag ?
                    <div className='calender-holder-dashboard calender-holder-card' ref={endDateRef}>
                      <Calendar value={moment(endDate).toDate()} inline onChange={(e) => {
                        setEndDateFlag(!endDateFlag)
                        const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                        setEndDate(formattedDate)
                      }} unstyled={false} minDate={new Date(DueDate)} />
                    </div> : null
                  }
                </div>
              </div>

              <div className='Tags'>
                <label>Department</label>
                <div className='newAddtaskDeptDiv'>
                  <div className='newAddTaskAssignee' onClick={() => {
                    setTagListInNewTaskAdd(true)
                  }}>
                    {seletedTagsForList && seletedTagsForList.length > 0 && seletedTagsForList.map((selectTagObj) => (
                      <div className='newTaskAssigneeContent newTaskTagContent' style={{ backgroundColor: selectTagObj.departmentColorCode }} >
                        <p style={{ width: 'fit-content' }}>{selectTagObj.departmentName}</p>
                      </div>
                    ))}
                  </div>
                  {(tagListForNewAddTask === true && (route === 'level' || route === 'projects')) &&
                    <div className='newddTagsListHolder' ref={newAddTagRef}>
                      <div className='seletedNewTaskAssignee'>
                        <div className='seletedNNewTaskAssigneeScroller'>
                          {seletedTagsForList && seletedTagsForList.length > 0 && seletedTagsForList.map((selectTagObj) => (
                            <div className='newTaskAssigneeContent tagForNewAddTask' style={{ backgroundColor: selectTagObj.departmentColorCode }}>
                              <p style={{ width: 'fit-content' }}>
                                {selectTagObj.departmentName}</p>
                              <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg"
                                onClick={() => {
                                  const updatedList = seletedTagsForList.filter(obj => obj !== selectTagObj);
                                  setSelectedTagsForList(updatedList);
                                  tagsList.push(selectTagObj)       
                                  setTagsList(tagsList)    
                                }}>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.139669 4.85991C-0.0465561 4.6737 -0.0465563 4.3718 0.139668 4.18559L1.8254 2.5L0.139668 0.814411C-0.0465563 0.628202 -0.0465561 0.326298 0.139669 0.140089C0.325894 -0.0461199 0.627824 -0.0461202 0.814049 0.140089L2.49978 1.82568L4.18595 0.139656C4.37218 -0.0465523 4.67411 -0.0465521 4.86033 0.139657C5.04656 0.325866 5.04656 0.62777 4.86033 0.813978L3.17416 2.5L4.86033 4.18602C5.04656 4.37223 5.04656 4.67413 4.86033 4.86034C4.67411 5.04655 4.37218 5.04655 4.18595 4.86034L2.49978 3.17432L0.814049 4.85991C0.627824 5.04612 0.325894 5.04612 0.139669 4.85991Z" fill="#263238" fill-opacity="0.6" />
                              </svg>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className='newTaskAssineeListContainer  newTaskTagsListContainer'>
                        {tagsList && tagsList.length > 0 && tagsList.map((tagObj) => (
                          <div className='TagContentDiv' style={{ backgroundColor: tagObj.departmentColorCode }} key={tagObj}
                            onClick={() => {
                              // Check if the tagObj is already in the selectedTagsForList
                              const isTagAlreadySelected = seletedTagsForList.some(item => item.departmentId === tagObj.departmentId);
                              if (!isTagAlreadySelected || setSelectedTagsForList.length === 0) {
                                setSelectedTagsForList([...seletedTagsForList, tagObj]);
                                setTagsList(tagsList?.filter(Obj => Obj?.departmentId !== tagObj?.departmentId))
                              }
                            }}>
                            <p>{tagObj.departmentName}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  }
                </div>
              </div>

              <div className='Assignee'>
                <label>Assigned to</label>

                {route === 'mytask' && route !== 'projects' ?
                  // Rendered when route is 'mytask'
                  (<div className='newTasksAssigneeDivCnt newnewTaskAssigneeContentEdite'>
                    <div className='img-holder'>
                      <img src={selfInfo && selfInfo.empImg ? selfInfo.empImg : profile} alt="" />
                    </div>
                    <div className='navBarName' style={{ width: 'fit-content' }}><p >{selfInfo.empFullName}</p></div>
                  </div>
                  )
                  :
                  route !== 'mytask' && route !== 'projects' && (view === 'month' || view === 'week' || view === 'day') ?
                    (<div className='newTaskAssigneeContent newnewTaskAssigneeContentEdite'>
                      <div className='img-holder'>
                        <img src={empInfo.empImg ? empInfo.empImg : profile} alt="" />
                      </div>
                      <p style={{ width: 'fit-content' }}>{selfInfoEmp.empFullName}</p>
                    </div>) :

                    // Rendered when route is not 'mytask'
                    <div className='newAddAsnListHld '>
                      <div className='newAddskAssigneeView newAddskAssigneeViewForTsk' onClick={() => {
                        setAssgneeListInNewTaskAdd(true)
                      }}>
                        <div className='newAddskAssigneeViewScoller'>
                          {seletedAssigneeForList && seletedAssigneeForList.length > 0 && seletedAssigneeForList.map((selectAssigneeObj) => (
                            <div className='newTaskAssigneeContent newTaskAssigneeContentEdite'>
                              <div className='img-holder'><img src={selectAssigneeObj && selectAssigneeObj.empImg ? selectAssigneeObj.empImg : profile} alt="" /></div>
                              <p style={{ width: 'fit-content' }}>{selectAssigneeObj.empFullName}</p>
                            </div>
                          ))}
                        </div>
                      </div>

                      {assigneeListNewTaskAdd &&
                        // Render the assignee list and selected assignees
                        <div className='assigneelistHolder' ref={assigneeRef}>
                          <div className='seletedNewTaskAssignee'>
                            <div className='seletedNNewTaskAssigneeScroller'>
                              {seletedAssigneeForList && seletedAssigneeForList.length > 0 && seletedAssigneeForList.map((selectAssigneeObj) => (
                                // Render selected assignees with remove button
                                <div className='newTaskAssigneeContent'>
                                  <div className='img-holder'><img src={selectAssigneeObj && selectAssigneeObj.empImg ? selectAssigneeObj.empImg : profile} alt="" /></div>
                                  <p style={{ width: 'fit-content' }}>{selectAssigneeObj.empFullName}</p>
                                  <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    onClick={() => {
                                      // Remove the object from seletedAssigneeForList
                                      setAssgneeListInNewTaskAdd(true)
                                      const updatedList = seletedAssigneeForList.filter(obj => obj !== selectAssigneeObj);
                                      setSelectedAssigneeForList(updatedList)
                                      assigneeList.push(selectAssigneeObj)       
                                      setAssineeList(assigneeList)                           
                                      }}>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.139669 4.85991C-0.0465561 4.6737 -0.0465563 4.3718 0.139668 4.18559L1.8254 2.5L0.139668 0.814411C-0.0465563 0.628202 -0.0465561 0.326298 0.139669 0.140089C0.325894 -0.0461199 0.627824 -0.0461202 0.814049 0.140089L2.49978 1.82568L4.18595 0.139656C4.37218 -0.0465523 4.67411 -0.0465521 4.86033 0.139657C5.04656 0.325866 5.04656 0.62777 4.86033 0.813978L3.17416 2.5L4.86033 4.18602C5.04656 4.37223 5.04656 4.67413 4.86033 4.86034C4.67411 5.04655 4.37218 5.04655 4.18595 4.86034L2.49978 3.17432L0.814049 4.85991C0.627824 5.04612 0.325894 5.04612 0.139669 4.85991Z" fill="#263238" fillOpacity="0.6" />
                                  </svg>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className='newTaskAssineeListContainer'>
                            <div className='newTaskAssineeListScrollerContainer'>
                              {assigneeList && assigneeList.length > 0 && assigneeList.map((assigneeObj) => (
                                // Render assignee options with click handler to add to selectedAssigneeForList
                                <div className='assineeListContentDiv' key={assigneeObj.empId}
                                  onClick={() => {
                                    // Check if the assigneeObj is not already in the list
                                    if (!seletedAssigneeForList.includes(assigneeObj)) {
                                      setSelectedAssigneeForList([...seletedAssigneeForList, assigneeObj]);
                                      setAssgneeListInNewTaskAdd(!assigneeListNewTaskAdd)
                                      handleSelectedAssignee(assigneeObj)
                                      setAssineeList(assigneeList?.filter(Obj => Obj?.empId !== assigneeObj?.empId))
                                      setAssgneeListInNewTaskAdd(true)
                                    }
                                  }}>
                                  <div className='img-holder'><img src={assigneeObj && assigneeObj.empImg ? assigneeObj.empImg : profile} alt="" /></div>
                                  <p>{assigneeObj.empFullName}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                }
              </div>


              <div className='Priority'>
                <label>Priority</label>

                <div className='newTaskAddTaskDiv'>
                  <div className='newAddTaskAssignee' onClick={() => {
                    setPriorityListForNewAddTask(!priorityListForNewAddTask)
                  }}>
                    <div className='newTaskAssigneeContent newnewTaskAssigneeContentEdite' style={{ backgroundColor: selectedPriority ? `${selectedPriority.priorityColorCode}` : null }}>
                      <p style={{ width: 'fit-content' }}>{selectedPriority ? selectedPriority.priority : null}</p>
                    </div>
                  </div>
                  {priorityListForNewAddTask &&
                    <div className='newAddTaskAssigneeList' ref={newAddPriorityRef}>
                      <div className='seletedNewTaskAssignee'>
                        <div className='seletedNNewTaskAssigneeScroller'>
                          <div className='newTaskAssigneeContent newTaskPriorityContent' style={{ backgroundColor: selectedPriority ? `${selectedPriority.priorityColorCode}` : null }}>
                            <p style={{ width: 'fit-content' }}>{selectedPriority ? selectedPriority.priority : null}</p>
                          </div>
                        </div>
                      </div>
                      <div className='newTaskAssineeListContainer newTaskTagsListContainer'>
                        {priorityList && priorityList.length > 0 && priorityList.map((priorityObj) => (
                          <div className='TagContentDiv' style={{ backgroundColor: priorityObj ? `${priorityObj.priorityColorCode}` : null }} key={priorityObj.priorityId}
                            onClick={() => {
                              handleSelectedPriority(priorityObj)
                              updatePriotityList(priorityObj)
                            }}>
                            <p>{priorityObj.priority}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  }

                </div>
              </div>

              <div className='Status'>
                <label>Status</label>

                <div className='newTaskAddTaskDiv'>
                  <div className='newAddTaskAssignee' onClick={() => {
                    setStatusListForNewAddTask(!statusListForNewAddTask)
                  }}>
                    <div className='newTaskAssigneeContent newTasStatusContentEdite' style={{ backgroundColor: selectedStatus ? `${selectedStatus.statusColorCode}` : null }}>
                      {selectedStatus.status}
                      {selectedStatus.statusId === 5 &&
                        <div className="requestedBox"></div>
                      }
                    </div>
                  </div>
                  {statusListForNewAddTask &&
                    <div className='newAddTaskAssigneeList newAddTaskStatusList' ref={newAddStatusRef}>
                      <div className='seletedNewTaskAssignee'>
                        <div className='seletedNNewTaskAssigneeScroller'>
                          <div className='newTaskAssigneeContent newTaskPriorityContent' style={{ backgroundColor: selectedStatus ? `${selectedStatus.statusColorCode}` : null }}>
                            <p style={{ width: 'fit-content' }}>{selectedStatus ? selectedStatus.status : null}</p>
                          </div>
                        </div>
                      </div>
                      <div className='newTaskAssineeListContainer newTaskTagsListContainer'>

                        {(self.role[0].role !== "ROLE_SUPERADMIN" && self.role[0].role !== "ROLE_ADMIN") && (
                          statusList && statusList.length > 0 && statusList.map((statusObj) => (
                            (statusObj.statusId !== 6 && statusObj.statusId !== 5) && (
                              <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                                handleSelectedStatus(statusObj)
                                updateStatusList(statusObj)
                              }}>
                                {statusObj.status}
                              </div>
                            )
                          ))
                        )}

                        {(self.role[0].role === "ROLE_SUPERADMIN" || self.role[0].role === "ROLE_ADMIN") && (
                          statusList && statusList.length > 0 && statusList.map((statusObj) => (
                            <div className='TagContentDiv' style={{ backgroundColor: `${statusObj.statusColorCode}` }} onClick={() => {
                              handleSelectedStatus(statusObj)
                              updateStatusList(statusObj)
                            }}>
                              {statusObj.status}
                            </div>
                          ))
                        )}

                      </div>
                    </div>
                  }
                </div>
              </div>
              <div className='Project'>
                <label>Project</label>

                <div className='newAddtaskPrtDiv'>
                  <div className='newAddProjectDiv' onClick={() => {
                    setProjectLitForNewAddTask(!projectListForNewAddTask)
                  }}>
                    <div className='newTaskAssigneeContent newnewTaskAssigneeContentEdite' >
                      <p style={{ width: 'fit-content' }}>
                        {selectedProject ? selectedProject.projectName : null}</p>
                    </div>
                  </div>
                  {projectListForNewAddTask && route !== 'projects' &&
                    <div className='newAddTaskAssigneeList newAddTaskStatusList' ref={newAddProjectRef}>
                      <div className='seletedNewTaskAssignee'>
                        <div className='seletedNNewTaskAssigneeScroller'>
                          <div className='newTaskAssigneeContent newTaskPriorityContent'>
                            <p style={{ width: 'fit-content' }}>{selectedProject ? selectedProject.projectName : null}</p>
                          </div>
                        </div>
                      </div>
                      <div className='newTaskAssineeListContainer newTaskTagsListContainer  newTaskProjectListContainer'>
                        <div className='newAddProjectscrollerGHlder'>
                          {tempProjectList && tempProjectList.length > 0 && tempProjectList.map((projectObj) => (
                            <div className='TagContentDiv' key={projectObj.projectId}
                              onClick={() => {
                                handleTaskProject(projectObj)
                                updateProjectList(projectObj)
                              }}>
                              <p>{projectObj.projectName}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className='addTskClrPrj' onClick={() => {
                        setSelectedProject(null)
                        setProjectLitForNewAddTask(false)
                        setTempProjectList(projectList)
                      }}>
                        Clear
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div className='commentsSection'>
                <div className='Comments'>
                  <div className='assigneePhoto'>
                    <div className='img-holder'>
                      <img style={{ height: '99%', width: '100%' }} src={selfInfoEmp?.empImg ? selfInfoEmp?.empImg : profile} id="newTaskAssigneeImg" alt='/' />
                    </div>
                    {/* <textarea rows={3} type='text' placeholder='Add Comment here...' className='addCommentsInput' value={addPostTaskComment} onChange={(e) => handlePostTaskComment(e)} style={{ color: '#263238' }} /> */}
                    {/* <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }}>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 0.6C2.34609 0.6 0.6 2.34609 0.6 4.5C0.6 6.65391 2.34609 8.4 4.5 8.4C6.65391 8.4 8.4 6.65391 8.4 4.5C8.4 2.34609 6.65391 0.6 4.5 0.6ZM0 4.5C0 2.01472 2.01472 0 4.5 0C6.98528 0 9 2.01472 9 4.5C9 6.98528 6.98528 9 4.5 9C2.01472 9 0 6.98528 0 4.5ZM2.45508 4.49991C2.45508 4.27398 2.5859 4.09082 2.74729 4.09082H4.0918V2.74631C4.0918 2.58493 4.27495 2.4541 4.50089 2.4541C4.72682 2.4541 4.90998 2.58493 4.90998 2.74631V4.09082H6.25378C6.41516 4.09082 6.54599 4.27398 6.54599 4.49991C6.54599 4.72585 6.41516 4.909 6.25378 4.909H4.90998V6.2528C4.90998 6.41419 4.72682 6.54501 4.50089 6.54501C4.27495 6.54501 4.0918 6.41419 4.0918 6.2528V4.909H2.74729C2.5859 4.909 2.45508 4.72585 2.45508 4.49991Z" fill="#263238" />
                    </svg> */}
                    <div className='editor-holder'>
                    <CKEditor
      editor={ClassicEditor}
      data={text}
      config={{
        toolbar: [
          'heading', '|',
          'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', '|',
          'alignment', '|',
          'bulletedList', 'numberedList', 'todoList', '|',
          'link', 'blockquote', 'code', 'codeBlock', '|',
          'insertTable', '|',
          'undo', 'redo', '|',
          'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', '|',
          'highlight', '|',
          'horizontalLine', 'pageBreak', '|',
          'specialCharacters', 'removeFormat'
        ],
        link: {
          decorators: {
            addTargetToExternalLinks: {
              mode: 'automatic',
              callback: url => /^(https?|ftp):\/\//.test(url),
              attributes: {
                target: '_blank',
                rel: 'noopener noreferrer'
              }
            }
          }
        }
      }}
      onChange={(event, editor) => {
        const data = editor.getData();
        const reqData = {
          editorData: editor.getData(),
          plainData: extractPlainText(data)
        };
        handlePostTaskComment(reqData);
        setText(data);
      }}
    />
                    </div>
                  </div>
                </div>
                <div className='documentAttachmentDiv'>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='AddTaskButton'>
          <button id='AddTaskBtn' onClick={clicked ? null : postTask}>{clicked ? <div className='taskLoader'></div> : "Add Tasks"}</button>
          <button id='CancelTaskBtn' onClick={() => { dispatch(setAddTask(false)) }}>Cancel</button>
        </div>
      </div>
    </div>
  )
}

export default NewAddTask